import axios from "axios";
import * as Library from "../utils/Library";
import { PLATFORM_NAME } from "../config/constant";

const axiosInstance = axios.create({
    baseURL: process.env.REACT_APP_API_URL
});

// Request interceptor to attach JWT
/*axiosInstance.interceptors.request.use(
    config => {
        const token = localStorage.getItem("accessToken");
        if (token) config.headers.Authorization = `Bearer ${token}`;
        return config;
    },
    error => {
        Promise.reject(error);
    }
);

// Response interceptor to handle errors
axiosInstance.interceptors.response.use(
    response => response,
    error => {
        const status = error.response?.status;
        if (status === 401) {
            console.warn("Unauthorized:", error.response?.data?.message || error.message);

            // start with 1 and increment by 1 each time
            const tokenFailedAttempt = localStorage.getItem("tokenFailedAttempt");
            const failedAttempt = tokenFailedAttempt ? parseInt(tokenFailedAttempt, 10) + 1 : 1;
            localStorage.setItem("tokenFailedAttempt", failedAttempt.toString());

            if (failedAttempt >= 3) {
                localStorage.removeItem("accessToken");
                document.cookie = "refreshToken=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/;";
                localStorage.removeItem("tokenFailedAttempt");
                if (window.location.pathname !== "/login") {
                    window.location.href = "/login?tokenExpired=true&reason=1";
                    console.warn("1 Redirecting to login after multiple failed attempts.");
                }
                return Promise.reject(new Error("Unauthorized after multiple failed attempts"));
            }

            //get the refresh token from cookies
            const refreshToken = document.cookie
                .split("; ")
                .find(row => row.startsWith("refreshToken="))
                ?.split("=")[1];

            if (!refreshToken) {
                // No refresh token available, redirect to login
                if (window.location.pathname !== "/login") {
                    window.location.href = "/login?tokenExpired=true&reason=5";
                    console.warn("4 Redirecting to login after multiple failed attempts.");
                }
                return;
            }

            // Attempt to refresh the token
            return Library.makeApiRequest({
                endpoint: "Accounts/refreshToken",
                headers: {
                    cookie: document.cookie
                },
                data: {
                    headers: {
                        cookie: document.cookie
                    },
                    rememberToken: true,
                    platform: PLATFORM_NAME
                }
            })
                .then(response => {
                    if (response.status !== 200) {
                        console.warn("Unauthorized access after token refresh attempt.");

                        localStorage.removeItem("accessToken");
                        document.cookie = "refreshToken=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/;";
                        if (window.location.pathname !== "/login") {
                            window.location.href = "/login?tokenExpired=true&reason=2";
                            console.warn("2 Redirecting to login after multiple failed attempts.");
                        }
                        return Promise.reject(new Error("Unauthorized after token refresh"));
                    }

                    const newToken = response?.data?.data?.accessToken;
                    const refreshToken = response?.data?.data?.refreshToken; //TODO: verify this, should not receive new refresh token

                    if (!newToken || !refreshToken) {
                        console.warn("New token or refresh token not found in response!", newToken);
                    }
                    localStorage.setItem("accessToken", newToken);

                    return new Promise((resolve, reject) => {
                        // Retry the original request with the new token
                        error.config.headers.Authorization = `Bearer ${newToken}`;
                        axiosInstance
                            .request(error.config)
                            .then(newRequestResponse => {
                                localStorage.removeItem("tokenFailedAttempt");
                                resolve(newRequestResponse);
                            })
                            .catch(reject);
                    });
                })
                .catch(refreshError => {
                    // If refresh fails, redirect to login or handle accordingly
                    localStorage.removeItem("accessToken");
                    document.cookie = "refreshToken=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/;";
                    if (window.location.pathname !== "/login") {
                        window.location.href = "/login?tokenExpired=true&reason=3";
                        console.warn("3 Redirecting to login after multiple failed attempts.");
                    }

                    return Promise.reject(refreshError);
                });
        } else if (status === 403) {
            console.warn("Forbidden:", error.response?.data?.message || error.message);
            if (window.location.pathname !== "/login") {
                window.location.href = "/login?tokenExpired=true&reason=5";
                console.warn("5 Redirecting to login after forbidden access.");
            }
        }

        return Promise.reject(error);
    }
);*/

export { axiosInstance };
